import { Injectable } from "@angular/core";
import { RestServiceBase } from "@definitiv-packages/angular-dba-library";
import { SicherungssystemModel } from "../../types/SicherungssystemModel";

@Injectable({
    providedIn: 'root'
})
export class SicherungssystemModelService extends RestServiceBase<SicherungssystemModel> {
    constructor(
    ) {
        super("SicherungssystemModel", false);
    }
}